<div class="title">{{ "new subtenant" | translate }}</div>
<app-subtenant-form #form (done)="store($event)"></app-subtenant-form>
<div class="row">
    <button mat-raised-button color="primary" (click)="form.submit()">
        {{ "create" | translate }}
    </button>
</div>
